import React from 'react';
import {Button, Row, Col } from 'antd';
import {Price} from '../../../lib/Common';
import ProductSummaryPlan from './ProductSummaryPlan';
import ProductSummarySchedule from './ProductSummarySchedule';
import _ from 'lodash';

/*
const prices = (items) => {
  const result=[];

  _.forEach(items, (item,key) => {
    result.push(<div key={key}>{item.name}</div>);
  });

  return result;
}
*/

const ProductSummary = ({item, jpy, onClosePanel}) => {
  return(
    <div className='drawr-travel'>
      <Row type='flex' gutter={8} className='mb-3'>
        <Col xs={8} md={24}>
          <div className="drawr-travel__img">
            <img className='border-1 rounded mw-100 mb-2' src={item.thumb} alt=''/>
            <img className='drawr-travel__label'
                 src='/themes/Bootstrap4-alpha6/dev/images/icon/sale.svg'
                 alt={`${item.name} - セール`}/>
          </div>
        </Col>
        <Col xs={16} md={24}>
          <div className='drawr-travel__guide'>{item.jguide ? '日本語ガイド' : '英語ガイド'}</div>
          <h3 className='drawr-travel__tour-title mb-0'>{item.name}</h3>
          <hr className='my-1'/>
          <div className="text-right">
            <Price item={item} jpy={jpy}/>
          </div>
        </Col>
      </Row>
      <hr/>

      {item.prices &&
      <ProductSummaryPlan item={item} jpy={jpy}/>
      }

      <hr/>

      <h3 className="drawr-travel__title">行ってきました写真！</h3>
      <p className="desc mb-1"><span className="text-danger">*</span> 写真はクリックで拡大できます。<br/>
        <span className="text-danger">*</span> 写真を拡大すると沢山の写真を観ることができます。</p>
      <Row type='flex' gutter={8} className='mb-3'>
        <Col xs={8}>
          <img className='border-1 rounded mw-100 mb-2' src='//tora-tora.net/tour/images/830__fitzroy-island1-min.jpg'
               alt=''/>
        </Col>
        <Col xs={8}>
          <img className='border-1 rounded mw-100 mb-2' src='//tora-tora.net/tour/images/830__fitzroy-island1-min.jpg'
               alt=''/>
        </Col>
        <Col xs={8}>
          <img className='border-1 rounded mw-100 mb-2' src='//tora-tora.net/tour/images/830__fitzroy-island1-min.jpg'
               alt=''/>
        </Col>
      </Row>

      <ProductSummarySchedule item={item}/>

      {/*
      <hr />
        {item.prices &&
          <section>
            {prices(item.prices)}
          </section>
        }
    <hr />
    <div className='card-travel__plan'>{item.plan_name}</div>
    */}
      <hr/>

      <h3 className="drawr-travel__title">このツアーについて</h3>
      <div className='drawr-travel__desc'>{item.intro}</div>
      <a href={item.url} className="btn btn-block btn-outline-primary btn-sm mb-3">このツアーの詳細を見る</a>
      <hr/>
      <div>
        <Button className="btn btn-dark btn-block" onClick={onClosePanel}>閉じる</Button>
      </div>
    </div>
  )
};

export default ProductSummary;



// WEBPACK FOOTER //
// ./src/pages/travel/components/ProductSummary.js